import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerspagesService } from '../../customerspages.service';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-case-study-stories',
  templateUrl: './case-study-stories.component.html',
  styleUrls: ['./case-study-stories.component.scss'],
  imports: [SlickCarouselModule, CommonModule, UrlParamsPipe],
})
export class CaseStudyStoriesComponent implements OnInit, OnChanges, OnDestroy {
  @Input() artData: any;
  queryParams: any;
  constructor(private customersPagesService: CustomerspagesService, private route: ActivatedRoute) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  stories: any;
  page = 1;

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    const data = this.artData;
    if (data != null) {
      if (data?.relatedCustomerStories) {
        this.stories = {
          cards: data?.relatedCustomerStories || [],
          header: data?.subpanelTitle || '',
        };
      }
    }
  }

  // =============Slider===============
  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    nav: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };
}
